import { Component, OnInit } from '@angular/core';
import { SEOService } from '../services/seo.service';

@Component({
  selector: 'app-chi-sono',
  templateUrl: './chi-sono.component.html',
  styleUrls: ['./chi-sono.component.scss']
})

export class ChiSonoComponent implements OnInit {

  pageTitle = "Chi Sono | Leone Lifestyle";
  desc = "Chi Sono"
  shareImg = "masthead-chi-sono.jpg";

  constructor(private seo: SEOService) {}

  ngOnInit(): void {
    this.seo.updatePageTags(this.pageTitle, this.desc, this.shareImg);
  }

}
